<template>
    <div class="vx-col w-full md:w-2/3 mb-base">
        <vx-card :title="data.title">
            <template slot="actions">
                <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
            </template>
            <div slot="no-body" class="p-6 pb-0">
                <div class="flex" v-if="data.chartData.analyticsData">
                    <div class="mr-6">
                        <p class="mb-1 font-semibold">This Month</p>
                        <p class="text-3xl text-success"><sup class="text-base mr-1">$</sup>{{ data.chartData.analyticsData.thisMonth.toLocaleString() }}</p>
                    </div>
                    <div>
                        <p class="mb-1 font-semibold">Last Month</p>
                        <p class="text-3xl"><sup class="text-base mr-1">$</sup>{{ data.chartData.analyticsData.lastMonth.toLocaleString() }}</p>
                    </div>
                </div>
                <vue-apex-charts
                        type=line
                        height=266
                        :options="data.chartData.chartOptions"
                        :series="data.chartData.series" />
            </div>
        </vx-card>
    </div>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'

    export default {
        name: "comparison-line",
        props: {
            data: Object
        },
        components: {
            VueApexCharts
        }
    };
</script>
